import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';

import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'components/Dropdown2';
import Message from 'components/Message';

import { REVIEWS_USERS_FILTERS_KEYS, ALL_USERS, INITIAL_VISITS_ONLY } from './RatingsUsersFilter.helpers';

const messages = defineMessages({
  label: {
    id: 'ratings-and-reviews.filters.label',
    defaultMessage: 'Type',
  },
  allVisits: {
    id: 'ratings-and-reviews.filters.all-visits',
    defaultMessage: 'All visits',
  },
  firstVisitOnly: {
    id: 'ratings-and-reviews.filters.first-visit-only',
    defaultMessage: 'First visit only',
  },
});

const messagesByFilter = {
  [ALL_USERS]: messages.allVisits,
  [INITIAL_VISITS_ONLY]: messages.firstVisitOnly,
};

function RatingsUsersFilter(props) {
  const { selectedUsersFilterKey, updateUserFilter } = props;
  const isActive = selectedUsersFilterKey !== REVIEWS_USERS_FILTERS_KEYS[0];

  return (
    <Dropdown attachment="left">
      <DropdownToggle label={messages.label} isActive={isActive}>
        <Message id={selectedUsersFilterKey} messages={messagesByFilter} />
      </DropdownToggle>
      <DropdownMenu>
        {REVIEWS_USERS_FILTERS_KEYS.map(filter => (
          <DropdownItem
            key={filter}
            isSelected={filter === selectedUsersFilterKey}
            onClick={() => updateUserFilter(filter)}>
            <Message id={filter} messages={messagesByFilter} />
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}

RatingsUsersFilter.propTypes = {
  selectedUsersFilterKey: PropTypes.oneOf(REVIEWS_USERS_FILTERS_KEYS),
  updateUserFilter: PropTypes.func,
};

export default RatingsUsersFilter;
